import { Button, Typography } from '@mui/material';
import Image from 'src/components/image';
import { useWorkspaceInviteUserDialog } from 'src/features/workspace/WorkspaceInviteUserDialog';
import { useLocales } from 'src/locales';
import { P2PImageContainer } from './styles';

export const ChatNavItemP2PInvite = () => {
  const { translate } = useLocales();

  const { showWorkspaceInviteUserDialog } = useWorkspaceInviteUserDialog();

  return (
    <P2PImageContainer>
      <Image
        disabledEffect
        src="/assets/illustrations/illustration_p2p_invite_members.svg"
      />
      <Typography variant="subtitle1" color="primary">
        {translate('header.nav_vertical.communicate.direct.invite_title')}
      </Typography>
      <Typography variant="caption" color="text.secondary" align="center">
        {translate('header.nav_vertical.communicate.direct.invite_content')}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={showWorkspaceInviteUserDialog}
      >
        {translate('shared.buttons.invite_member')}
      </Button>
    </P2PImageContainer>
  );
};
